module.exports = __webpack_public_path__ + "img/dyh_code.5022de9f.png";